import React from 'react';

import styled from 'styled-components';

import ModelDetailsHeaderAgencies from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsHeader/ModelDetailsHeaderAgencies';
import { NameCell, ModelCoverWrapper } from '@components/ContactsSelector/ModelsSelector/ModelsWall/ModelsTable/ModelsTableUI';
import { ModelCover } from '@components/ModelCover';

const SeasonModelCell = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    min-height: 5rem;
    width: 100%;
    max-width: 28rem;

    ${ModelCoverWrapper} {
        flex-shrink: 0;
    }

    ${NameCell} {
        flex: 1;
        min-width: 0;
        padding-top: 0.15rem;

        .name h1 {
            font-size: 1.1rem;
            line-height: 1.1;
            margin: 0;
            text-transform: capitalize;
        }

        .detail {
            margin-top: 0.25rem;
        }
    }
`;

const ShowSeasonModelsTableColumnModel = ({ record }) => {
    return (
        <SeasonModelCell>
            <ModelCoverWrapper>
                <ModelCover maxWidth={60} model={record} classN="model-cover-small" />
            </ModelCoverWrapper>
            <NameCell>
                <div className="name">
                    <h1>{record.name.toLowerCase()}</h1>
                </div>
                <div className="detail">
                    <ModelDetailsHeaderAgencies readOnly model={record} />
                </div>
            </NameCell>
        </SeasonModelCell>
    );
};

export default ShowSeasonModelsTableColumnModel;
